













































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import {
  SurveyInfo,
  TsEqGridChartLegends,
  TsManagerRating,
  TsManagerRatingAvarageScore,
  TsManagerRatingTypeEnum,
  TsRateeRatingResults,
  TsRateeReportsFields,
  TsRateeReview,
  TsRateeUser,
  TsUserDto,
  User
} from '@/interfaces'
import { Getter } from 'vuex-class'
import TsService from '@/services/TsService'
import UsersRateeCard from '@/components/360/UsersRateeCard.vue'
import BarChart from '@/components/360/BarChart.vue'
import DialChart from '@/components/360/DialChart.vue'
import EqGridChart from '@/components/360/EqGridChart.vue'
import AppFooter from '@/components/footer/AppFooter.vue'
import dayjs from 'dayjs'
import download from 'downloadjs'

@Component({
  name: 'RaterRateeResultsPage',
  components: {
    UsersRateeCard,
    BarChart,
    DialChart,
    EqGridChart,
    AppFooter
  }
})
export default class RaterRateeResultsPage extends Vue {
  @Prop({ required: true })
  tsSurveyId !: number

  @Prop({ required: true })
  tsRaterRateeId !: number

  @Getter('user/currentUser')
  user!: User

  @Getter('ts/getUsers')
  tsUserInfo!: TsUserDto

  @Getter('user/isAuthenticated')
  isAuthenticated!: boolean

  @Getter('survey/getDisplayedBaseSurveyInfo')
  surveyInfo!: SurveyInfo

  @Watch('activeRateeReview')
  async onActiveRateeReviewChanged () {
    await this.prepareRatingReviews()
  }

  ratee: TsRateeUser | null = null
  rateeReviewsPeriods: TsRateeReview[] = []
  averageEverydayScore: TsManagerRatingAvarageScore | null = null
  lastTen: TsManagerRating[] | null = null
  ratingReviews: object | null = null
  activeRateeReview: TsRateeReview | null = null
  rateeRatingResults: TsRateeRatingResults | null = null
  dataFields: TsRateeReportsFields[] = [
    {
      label: `${this.$t('ts.results.review_period')}`,
      labelMobile: `${this.$t('ts.results.review_period_sm')}`,
      key: 'timeCreated',
      sortable: true
    },
    {
      label: `${this.$t('ts.results.table_average_score')}`,
      labelMobile: `${this.$t('ts.results.table_average_score_sm')}`,
      key: 'score',
      sortable: true
    },
    {
      label: '',
      key: 'id'
    }
  ]
  eqChartLegends: TsEqGridChartLegends[] = [
    {
      label: 'Emerging Talent',
      bgColor: '#e1e6e9',
      borderColor: '#3d5a8033'
    },
    {
      label: 'Local Talent Pool',
      bgColor: '#d6efff',
      borderColor: '#3d5a8033'
    },
    {
      label: 'Global Talent Pool',
      bgColor: '#f7fcff',
      borderColor: '#3d5a8033'
    }
  ]

  async created () {
    this.ratee = await TsService.getRateeInfoById(this.tsRaterRateeId)
    this.averageEverydayScore = await TsService.getManagerRatingAvarageScore(this.tsRaterRateeId, TsManagerRatingTypeEnum.EVERYDAY)
    this.rateeReviewsPeriods = await TsService.getRateeReviewsPeriods(this.tsRaterRateeId)
    this.lastTen = await TsService.getManagerRatingLastTen(this.tsRaterRateeId, TsManagerRatingTypeEnum.EVERYDAY)
    this.rateeRatingResults = await TsService.getRateeRatingResults(this.tsRaterRateeId)
  }

  async prepareReport (rateeReviewId: number): Promise<void> {
    const blobPdfFile = await TsService.downloadRateeReviewsReport(this.tsRaterRateeId, rateeReviewId)
    const fileName = this.ratee
      ? `Report ${this.ratee.fullName} ${dayjs().format('DD//MM//YYYY HH:mm')}`
      : `Report ratee - ${this.tsRaterRateeId}, review - ${rateeReviewId} ${dayjs().format('DD//MM//YYYY HH:mm')}`

    download(blobPdfFile, fileName, 'application/pdf')
  }

  setActiveReview (review: TsRateeReview): void {
    this.activeRateeReview = review
  }

  scoreFormat (score: string): string {
    return `${(parseFloat(score) * 10).toFixed(1)}%`
  }

  ratingFormat (rating: number): string {
    const integerPart = Math.trunc(rating)
    const decimalPart = rating - integerPart

    const numberFractionDigits = decimalPart > 0 ? 1 : 0

    return `${rating.toFixed(numberFractionDigits)}%`
  }

  get formattedLastTen () : Chart.ChartData | null {
    const { lastTen } = this
    if (!lastTen) {
      return null
    }

    const labels = lastTen.map(item => {
      return item.timeCreated ? dayjs(item.timeCreated).format('ddd Do') : ''
    })

    const values = lastTen.map(item => {
      return parseInt(this.prepareScoreNumberToFloat(parseInt(item.score)))
    })

    return {
      labels: labels,
      datasets: [
        {
          backgroundColor: '#0085cd',
          data: values
        }
      ]
    }
  }

  get preparedAvarageScore () : string | null {
    if (!this.averageEverydayScore) {
      return null
    }

    return this.prepareScoreNumberToFloat(this.averageEverydayScore.score)
  }

  get formattedAverage () : Chart.ChartData | null {
    if (!this.preparedAvarageScore) {
      return null
    }

    const restScore = 10 - parseInt(this.preparedAvarageScore)

    return {
      datasets: [
        {
          backgroundColor: ['#0085cd', '#d6efff'],
          data: [parseInt(this.preparedAvarageScore), restScore]
        }
      ]
    }
  }

  get barChartOptions () : Chart.ChartOptions | null {
    return {
      legend: {
        display: false
      },
      scales: {
        yAxes: [
          {
            ticks: {
              min: 0,
              max: 10,
              stepSize: 5
            },
            gridLines: {
              borderDash: [4, 4]
            }
          }
        ],
        xAxes: [
          {
            gridLines: {
              display: false
            }
          }
        ]
      }
    }
  }

  get dialChartOptions () : Chart.ChartOptions | null {
    return {
      cutoutPercentage: 80,
      rotation: Math.PI,
      circumference: Math.PI,
      legend: {
        display: false
      },
      tooltips: {
        enabled: false
      },
      plugins: {
        doughnutlabel: this.preparedAvarageScore
      }
    }
  }

  prepareScoreNumberToFloat (score: number): string {
    return (score / 10).toFixed(1)
  }
  goToList (): void {
    this.$router.push({
      name: 'survey.ts.dashboard',
      params: {
        tsSurveyId: this.tsSurveyId.toString()
      }
    })
  }

  async prepareRatingReviews () {
    if (!this.activeRateeReview) {
      return
    }

    this.ratingReviews = await TsService.getRateeRatingReviews(this.tsRaterRateeId, this.activeRateeReview.id)
  }
}
